import ReducerUtils                   from "../../../utils/ReducerUtils"
import Actions                        from "../../../model/constant/actions"

const Saving = ReducerUtils.createReducer<boolean>(false,{
  [Actions.SAVING_NEW_PACY_CONFIGS] : (state,action) => action.status
})

export default Saving
